import type { CompanyUser } from "@/apis/gql/types";
import { CompanyRole } from "@/lib/miscellaneous/authorization";
import { useTenant } from "@/providers/session";

export const useShouldWaitForClientApproval = () => {
  const { hasCostCenters, companyUsers } = useTenant();

  const hasUserWithClientRole = companyUsers?.some(
    (user: CompanyUser) => user.companyRole === CompanyRole.CLIENT,
  );

  return hasCostCenters && hasUserWithClientRole;
};
